<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
      @checkPod="checkPod"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @batchConfirm="batchConfirm"
        @batchRefuse="batchRefuse"
        @batchExport="batchExport"
        @updateGoods="updateGoods"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <UpdateGoods
      :visible.sync="goodsDialogOption.visible"
      :title="goodsDialogOption.title"
      :waybillDetailCode="goodsDialogOption.waybillDetailCode"
      :custCode="goodsDialogOption.custCode"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import UpdateGoods from '../update-goods/dialog'
export default {
  components: {
    PageMain,
    PageHeader,
    UpdateGoods,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      fullScreenLoading: false,
      goodsDialogOption: {
        visible: false,
        title: '更新货物信息',
        waybillDetailCode: '',
      },
      updateGoodsStatusList: ['1', '2', '3', '4'],
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .carriageWaybillDetailListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    batchConfirm() {
      const data = this.$refs.main.getTableCheckedData(true)
      let listCode = []
      data.forEach((item) => {
        listCode.push(item.dispatchOrderCode)
      })
      this.$confirm('是否要对所选回单，进行【确认】操作？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.checkPod(listCode, 'Y')
      })
    },
    batchRefuse() {
      const data = this.$refs.main.getTableCheckedData(true)
      let listCode = []
      data.forEach((item) => {
        listCode.push(item.dispatchOrderCode)
      })
      this.$confirm('是否要对所选回单，进行【拒绝】操作？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.checkPod(listCode, 'R')
      })
    },
    checkPod(listCode, podStatus, waybillDetailCodeList) {
      let data = {
        listCode,
        wayBillPodStatus: podStatus,
        waybillDetailCodeList: waybillDetailCodeList,
      }
      this.fullScreenLoading = true
      this.$api
        .carriageWaybillUpdateStatusApi(data)
        .then((res) => {
          this.fullScreenLoading = false
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.reload()
        })
        .catch(() => {
          this.fullScreenLoading = false
        })
    },
    batchExport() {
      this.$refs.main.batchExport()
    },
    //货物信息
    updateGoods() {
      const data = this.$refs.main.getTableCheckedData(true)
      if (!data) return
      if (data.length > 1) {
        this.$message.warning('请选择一个订单进行更新！')
        return
      }
      const { waybillDetailCode, custCode, bizStatus, v_bizStatus } = data[0]
      if (this.updateGoodsStatusList.includes(bizStatus)) {
        this.goodsDialogOption = {
          visible: true,
          title: '更新货物信息',
          waybillDetailCode: waybillDetailCode,
          custCode: custCode,
        }
      } else {
        this.$message.warning(
          `当前单据状态为    ${v_bizStatus}   不能更新货物信息`
        )
      }
    },
  },
}
</script>
